import React from 'react';
import styled from 'styled-components';
import ArticleNum from './ArticleNum';
import EducationSvg from '../assets/svg/edu-skills.svg';
import { backgroundData } from '../data/AboutData';

function BackgroundCont() {
    return (
        <BackgroundWrapper>
            <ArticleNum number="02" title="BACKGROUND" />
            <div className="back-container">
                {backgroundData.map(data => (
                    <div key={data.title}  className='back-card' >
                        <img src={data.photo} alt="" />
                        <p className="fs-2 heading center">{data.title}</p>
                        <p className='text-tertiary justify' >
                            {data.desc}
                        </p>

                    </div>
                ))}
            </div>
        </BackgroundWrapper>
    );
}

const BackgroundWrapper = styled.div`
    width: 100%;
    padding: 3rem 0rem;

    .back-container{
        width: 80%;
        display: inline-block;
        margin: 7rem auto;
        display: grid;
        
        grid-template-columns: repeat(auto-fit, minmax(300px, 4fr)); 
        grid-gap: 4rem;
    }
    .back-card{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .heading{
        color: var(--primary);
        margin: 2rem 0rem;
    }

`;

export default BackgroundCont;